import React, { Component} from 'react';
import {Container} from 'semantic-ui-react';
class SubscribeDescription extends Component {

    render () {
        return (
            <Container style={{paddingTop:'2em'}}>
            <div>
                <h3>Subscribe to our services in AWS</h3>
                <p>
                    Our endpoint is delivered to you through AWS Marketplace SaaS product. Follow <a href="#">this
                    link </a>
                    to subscribe to our product.</p>
                <p>
                    After subscription you will be redirected to our registration page, where you can create your
                    account
                    and get assigned a unique token.
                    That token will be used in all of the future requests to our endpoints.</p>
                <p>You can then access your API token at any time by signing in the top right corner of the
                    menu.
                </p>
            </div>
            </Container>
        )
    }
}

export default SubscribeDescription;



/** WEBPACK FOOTER **
 ** ./src/pages/GettingStarted/SubscribeDescription.js
 **/